'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_SitesView$$anon$39() {
  this.bzW = null;
  this.bzU = null;
  this.bzV = false;
  this.bzS = null;
  this.bzT = false;
  this.bzX = false;
  this.bzY = false;
  this.bzW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_SitesView$$anon$39 as $c_Lpresto_SitesView$$anon$39 };
$p = $c_Lpresto_SitesView$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SitesView$$anon$39;
/** @constructor */
function $h_Lpresto_SitesView$$anon$39() {
}
export { $h_Lpresto_SitesView$$anon$39 as $h_Lpresto_SitesView$$anon$39 };
$h_Lpresto_SitesView$$anon$39.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bzW;
});
$p.t = (function() {
  if ((!this.bzV)) {
    this.bzU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bzV = true;
  }
  return this.bzU;
});
$p.ag = (function() {
  if ((!this.bzT)) {
    this.bzS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vn(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bzT = true;
  }
  return this.bzS;
});
$p.v = (function() {
  if ((!this.bzY)) {
    this.bzX = false;
    this.bzY = true;
  }
  return this.bzX;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_SitesView$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SitesView$$anon$39, "presto.SitesView$$anon$39", ({
  RP: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_SitesView$$anon$39 as $d_Lpresto_SitesView$$anon$39 };
//# sourceMappingURL=presto.-Sites-View$$anon$39.js.map
